<template id="tooltip"  >
<v-tooltip
  v-model="show"
  max-width="600px"
  content-class="tooltip-content"
  bottom
  >
  <template v-slot:activator="{  }">
    <div
      @mouseover="mouseover"
      @mouseleave="mouseleave"
    >
      <slot></slot>
    </div>
  </template>
  <template v-slot:default>
    <v-card
      @mouseover="mouseover"
      @mouseleave="mouseleave"
      >
      <v-row dense>
        <v-col>
          <v-card-title class="headline">
            <div class="v-tooltip-title row">{{title}}</div>
            <div v-if="description !==null" class="v-tooltip-separation row"></div>
            <div v-if="description!==null" class="v-tooltip-description "> {{descriptionText}} <br/></div>
            <div v-if="imgLink!==null" class="v-tooltip-img-div">
                <img class="v-tooltip-img" :src="imgLink" alt="..."/>
            </div>
          </v-card-title>
        </v-col>
      </v-row>
    </v-card>
  </template>
</v-tooltip>
</template>
<script>
    import Vue from 'vue';
    import Vuetify from 'vuetify';
    Vue.use(Vuetify);

    export default {
        name: 'tooltip-info',
        props: {
            title:String,
            description:String,
        },
        data() {
            return {
                show: false,
                hoverTimer: null,
                imgLink:this.getImgLink(),
                descriptionText:this.getDescriptionText()

            };
            
        },
        computed: {
           
        },
        methods:{
           mouseover: function() {
                console.log(`mouseover`);
                this.show = true;
                clearTimeout(this.hoverTimer);
            },
            mouseleave: function() {
                console.log(`mouseleave`);
                this.hoverTimer = setTimeout(() => {
                    this.show = false;
                }, 0);
            },
            detectURLs(message) {
                var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
                return message.match(urlRegex);
            },
            getImgLink(){
                if(this.description!==null){
                return this.detectURLs(this.description);
                }
                return null;
            },
            getDescriptionText(){
                if(this.description!==null){
                    let imgU=this.getImgLink();
                    if(imgU!==null){
                        var text = this.description.replace(imgU,'');
                        return text;
                    }
                    return this.description;
                }
                return null;
            }
  
        } 
    }
</script>
